module.exports = __webpack_public_path__ + "img/complaint_red.6f8bc19d.png";